export const event = {
  edition: 24,
  year: 2026,
  title: 'Brent Bought a Big Damn Turkey',
  theme: 'I went and did it again',
  date: '2026-12-12',
  time: '19:00',
  timezone: 'America/New_York',
  displayDate: 'Saturday, December 12, 2026',
  displayTime: '7:00 PM',
  rsvpDeadline: 'December 5, 2026',
  location: 'Location details will be shared with confirmed guests.',
  potluck: 'Bring a favorite dish, drink, or snack to share.',
  hostProvides: 'Brent provides the big damn turkey and the main-event energy.',
  guestPolicy: 'Include everyone in your party when you RSVP (up to five total).',
};

